import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { EndpointResponse } from '@/types/endpoints';
import type { PricesPatch, PricingItem } from '@/types/pricing';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

/**
 * A record replaces that price's amount and currency (its presentation is kept), and `null` clears it. Never send
 * promotions or custom prices: kitchensink binds the body over the stored item and saves every association it holds.
 */
export type PricingItemPatch = PricesPatch;

export const patchPricingItem = async (
  scope: RequestScope,
  { id, data }: { id: number; data: PricingItemPatch },
  options: WriteRequestOptions
): Promise<EndpointResponse<PricingItem>> => {
  try {
    const response = await scopedApi(scope).patch<EndpointResponse<PricingItem>>(`pricing_item/${id}`, data, options);
    return response.data;
  } catch (error) {
    return utils.error.handleAxiosError(error, { redactRequestData: true });
  }
};
